import { Card, CardContent, CardHeader, Grid, Typography, Divider, Chip, Tooltip, IconButton, Button } from '@mui/material'
import moment from 'moment';
import addCommas from '../../utils/functions/commas';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import 'moment/locale/th';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

function CardPaymentHistory({ row, onShowReceipt }) {
  return (
    <Card sx={{ height: '100%', borderRadius: 2, p: 2, boxShadow: 5, backgroundColor: '#F5F5F5'}}>
        <Chip
            label={moment(row.pay_date).utc().locale('th').format('DD MMM YYYY')}
            color='primary'
            size='small'
            icon={ <CreditScoreIcon sx={{ fontSize: 16 }}/>}
            sx={{ color: '#FFFFFF' }}
        />
        <CardHeader title={row.descriptions ? row.descriptions : 'ไม่มีชื่อรายการ'}/>
        <Divider sx={{ my: 1 }} />
        <CardContent>
            <Grid container spacing={2}>
            <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                เลขที่ใบแจ้งหนี้:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="body2" sx={{ textAlign: 'right' }}>
                {row.invoice_no}
                </Typography>
            </Grid>
            </Grid>
            <Grid container spacing={2}>
            <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                เลขที่อ้างอิง:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="body2" sx={{ textAlign: 'right' }}>
                {row.payment_reference_id}
                </Typography>
            </Grid>
            </Grid>
            {/* <Grid container spacing={2}>
            <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                วันที่ชำระเงิน:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="body2" sx={{ textAlign: 'right' }}>
                {moment(row.pay_date).utc().format('YYYY-MM-DD')}
                </Typography>
            </Grid>
            </Grid> */}
            <Grid container spacing={2}>
            <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                จำนวนเงิน:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="body2" color='primary' fontWeight="bold" sx={{ textAlign: 'right' }}>
                {addCommas(row.total_amount, 2)}
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex' ,justifyContent: 'flex-end' }}>
                <Button 
                    variant='contained' 
                    sx={{ color: '#fff'}} 
                    size='small'
                    onClick={() => onShowReceipt(row.order_id)}
                >
                    ใบเสร็จชำระเงิน
                </Button>
                {/* <Tooltip title="ดูใบเสร็จชำระเงิน" arrow>
                    <span>
                        <IconButton
                        onClick={() => handlePreviewPdf(row.order_id)}
                        >
                        <ReceiptLongIcon
                            color='primary'
                        />
                        </IconButton>
                    </span>
                </Tooltip> */}
            </Grid>
            </Grid>
        </CardContent>
    </Card>
  )
}

export default CardPaymentHistory